import {
  ADD_SOFTSKILL_ABILITY_USER,
  ADD_SOFTSKILL_ABILITY_USER_SUCCESS,
  ADD_SOFTSKILL_ABILITY_USER_CLEAN,
  ADD_SOFTSKILL_ABILITY_USER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  abilityUser: {},
}

const SoftskillAbilityUserAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SOFTSKILL_ABILITY_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_SOFTSKILL_ABILITY_USER_SUCCESS:
      state = {
        ...state,
        abilityUser: action.payload.abilityUser,
        loading: false,
        done: true,
      }
      break
    case ADD_SOFTSKILL_ABILITY_USER_CLEAN:
      state = initialState
      break
    case ADD_SOFTSKILL_ABILITY_USER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillAbilityUserAdd
